import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=3e060308&scoped=true&"
import script from "./publish.vue?vue&type=script&lang=js&"
export * from "./publish.vue?vue&type=script&lang=js&"
import style0 from "./publish.vue?vue&type=style&index=0&id=3e060308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e060308",
  null
  
)

export default component.exports